import { mount } from 'mount-vue-component';
import mitt from 'mitt';
import DModal from './DModal.vue';
import { registerComponents, vueUse, registerComponentProgrammatic } from '../../../utils/plugins';
import { removeElement } from '../../../utils/helpers';

const components = {
  DModal,
};

/**
 *
 * @param {import('vue').App} app
 * @returns
 */
const ModalProgrammatic = (app) => {
  const open = (params) => {
    let content;
    if (typeof params === 'string') content = params;

    const emitter = mitt();
    const defaultParam = {
      programmatic: true,
      content,
      programmaticEmit: emitter.emit,
    };
    delete params.parent; // removing parent from params since it's ignored now
    const propsData = Object.assign(defaultParam, params);
    const modal = mount(DModal, {
      props: propsData,
      app,
    });

    emitter.on('destroy', () => {
      emitter.all.clear();
      removeElement(modal.el);
      modal.destroy();
    });

    return modal;
  };

  return {
    open,
  };
};

const Registered = {
  install(Vue) {
    registerComponents(Vue, components);
    registerComponentProgrammatic(Vue, '$modal', ModalProgrammatic(Vue));
  },
};

vueUse(Registered);

export default Registered;

export {
  DModal,
  ModalProgrammatic,
};